// extracted by mini-css-extract-plugin
export default {"navbarStyles":"Navbar_navbarStyles__77nCK"};